exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout-container__tab-panel[data-v-51a20097]{height:44px}.is-sticky[data-v-51a20097]{position:fixed;top:110px;left:0;right:0;z-index:10;padding-left:3rem;padding-right:3rem;transform:translateY(-100%)}", ""]);

// exports
